(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rm-product-card"] && !Shopify.designMode) return;
  try {
    /* Delegated add-to-cart for every rm-card on the page. The form posts normally
   if JS fails or the fetch errors, so the button is never a dead end. */
(function () {
  if (window.__rmCardAddBound) return;
  window.__rmCardAddBound = true;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-rm-add]');
    if (!form) return;

    e.preventDefault();

    var btn   = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-rm-add-label]');
    var was   = label ? label.textContent : '';

    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: 1
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (label) label.textContent = 'Added ✓';
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (n) {
              n.textContent = '(' + cart.item_count + ')';
            });
          });
      })
      .catch(function () {
        /* Fall back to the real form post rather than stranding the buyer. */
        form.submit();
      })
      .finally(function () {
        setTimeout(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = was;
        }, 1600);
      });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rm-search-engine"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.RMSearch) return;

  var INDEX_URL = '/collections/all?view=search-index';
  // v2: entries carry the product id (d) for search-click tracking.
  var CACHE_KEY = 'rm-search-index-v2';
  var products  = null;
  var loading   = false;
  var waiters   = [];
  var failures  = 0;
  var complete_ = false;   // true once the whole catalogue is loaded
  var commonTags = null;

  /* ── Normalisation ──
     "MS-01" -> "ms 01", '19" Rack' -> "19 rack", "M710q-M920q" -> "m710q m920q" */
  function norm(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* Tags are worth searching — "pfsense", "proxmox", "FG-80F" and brand tags
     like "Unifi" (on the UNVR Instant, whose title never says Unifi) exist only
     as tags. But boilerplate tags sit on nearly every product and would flood
     results, so drop any tag common enough to be meaningless. Frequency-based
     rather than a hardcoded list, so it keeps working as the catalogue grows. */
  var COMMON_TAG_RATIO = 0.25;
  function buildCommonTags(list) {
    commonTags = {};
    if (list.length < 20) return;
    var freq = {};
    list.forEach(function (p) {
      var seen = {};
      (p.g ? p.g.split('|') : []).forEach(function (t) {
        var k = norm(t);
        if (k && !seen[k]) { seen[k] = 1; freq[k] = (freq[k] || 0) + 1; }
      });
    });
    var cutoff = list.length * COMMON_TAG_RATIO;
    Object.keys(freq).forEach(function (k) { if (freq[k] > cutoff) commonTags[k] = 1; });
  }

  /* Extra search terms, from the product's custom.search_terms metafield (k in
     the index). This is the fix for a buyer word the title and tags do not
     carry, e.g. "elitedesk" for the "HP Elite/ProDesk Mini" listing: add the
     words in Shopify admin and the next index load finds it, no theme change. */
  function terms(p) {
    return Array.isArray(p.k) ? p.k.join(' ') : String(p.k || '');
  }
  function haystack(p) {
    if (p.__hay) return p.__hay;
    var parts = [p.t, p.v || '', p.y || '', terms(p)];
    (p.g ? p.g.split('|') : []).forEach(function (t) {
      var k = norm(t);
      if (k && !(commonTags && commonTags[k])) parts.push(k);
    });
    p.__hay = norm(parts.join(' '));
    return p.__hay;
  }

  /* Model ranges. Titles name a family as a range, "M710q-M920q" or "Fits All
     3000-7000 Series", and buyers type one model, "m720q" or "optiplex 7070",
     which matched nothing. A range is two codes with the same letters around
     an increasing number; a bound ending in 000 or 00 means the whole series
     ("7000" covers 7070). Bare-number ranges need 3+ digits, so a model code
     like "PS82-96" never makes "90" match, and only count alongside another
     word ("optiplex 7070"): alone, "5268" or "4200" would pull in the OptiPlex
     and Mac Mini listings. */
  var RANGE_RE = /([a-z]*)(\d+)([a-z]*)\s*-\s*([a-z]*)(\d+)([a-z]*)/gi;
  function ranges(p) {
    if (p.__ranges) return p.__ranges;
    var out = [], text = p.t + ' ' + terms(p), m;
    RANGE_RE.lastIndex = 0;
    while ((m = RANGE_RE.exec(text))) {
      var pre = m[1].toLowerCase(), suf = m[3].toLowerCase();
      if (pre !== m[4].toLowerCase() || suf !== m[6].toLowerCase()) continue;
      var lo = +m[2], hi = +m[5];
      if (!(lo < hi)) continue;
      if (!pre && !suf && (m[2].length < 3 || m[5].length < 3)) continue;
      var zeros = /0+$/.exec(m[5]);
      if (zeros && zeros[0].length >= 2 && zeros[0].length < m[5].length) hi += Math.pow(10, zeros[0].length) - 1;
      out.push({ pre: pre, suf: suf, lo: lo, hi: hi });
    }
    p.__ranges = out;
    return out;
  }
  function inRange(t, p, solo) {
    var m = /^([a-z]*)(\d+)([a-z]*)$/.exec(t);
    if (!m) return false;
    var n = +m[2];
    return ranges(p).some(function (r) {
      if (solo && !r.pre && !r.suf) return false;
      return r.pre === m[1] && r.suf === m[3] && n >= r.lo && n <= r.hi;
    });
  }

  /* "19in" and "10in" mean the rack size; titles write 19". */
  function queryTokens(q) {
    return norm(q).split(' ')
      .map(function (t) { return t.replace(/^(10|19)in(ch(es)?)?$/, '$1'); })
      // Titles write the format as 19" / 10", never "19 inch", so a typed
      // "inch" has nothing to land on. Drop it rather than fail the query.
      .filter(function (t) { return t && t !== 'inch' && t !== 'inches'; });
  }

  /* Every word of the query must hit, in any order. A token hits if it prefixes
     any word in the haystack, or appears in the punctuation-stripped haystack
     (so "ms01" still finds "MS-01"). */
  function matches(q, p) {
    var hay      = haystack(p);
    var words    = hay.split(' ');
    var squashed = hay.replace(/ /g, '');
    var tokens = queryTokens(q);
    if (!tokens.length) return false;

    return tokens.every(function (t) {
      // Bare numbers match whole words only. Prefix-matching them is far too
      // loose: "10" would otherwise hit 10G, 1005T and 108P.
      var exact = /^\d+$/.test(t);
      for (var i = 0; i < words.length; i++) {
        if (exact ? words[i] === t : words[i].indexOf(t) === 0) return true;
      }
      if (!exact && squashed.indexOf(t) !== -1) return true;
      return inRange(t, p, tokens.length === 1);
    });
  }

  /* Rank: a title hit beats a tag-only hit, and a shorter title wins ties so
     the specific product outranks a combined listing that merely mentions it. */
  function score(q, p) {
    var t = norm(p.t), s = 0;
    queryTokens(q).forEach(function (tok) {
      if (t.indexOf(tok) === 0) s += 6;
      else if ((' ' + t).indexOf(' ' + tok) !== -1) s += 4;
      else if (t.replace(/ /g, '').indexOf(tok) !== -1) s += 2;
      else if (inRange(tok, p)) s += 4;
    });
    return s * 1000 - p.t.length;
  }

  function money(cents) {
    if (cents == null) return '';
    if (window.Shopify && window.Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function card(p) {
    var url  = '/products/' + p.h;
    var sale = p.c > p.p
      ? '<span class="rm-card__sale">-' + Math.round((p.c - p.p) / p.c * 100) + '%</span>' : '';
    var was  = p.c > p.p ? '<s class="rm-card__was">' + money(p.c) + '</s>' : '';
    var img  = p.m
      ? '<img class="rm-card__img" src="' + p.m + '" alt="' + esc(p.t) + '" loading="lazy" width="400" height="400">'
      : '<div class="rm-card__img rm-card__img--empty"></div>';

    // Anything with real options links out to choose — adding a default variant
    // blind is how a buyer ends up with the wrong half of a modular mount.
    var action = (p.n > 1 || !p.a)
      ? '<a href="' + url + '" class="rm-card__add rm-card__add--options">' + (p.a ? 'Options' : 'View') + '</a>'
      : '<form method="post" action="/cart/add" class="rm-card__form" data-rm-add>'
        + '<input type="hidden" name="id" value="' + p.i + '">'
        + '<input type="hidden" name="quantity" value="1">'
        + '<button type="submit" class="rm-card__add"><span data-rm-add-label>Add</span></button></form>';

    return '<div class="rm-card" data-product-id="' + (p.d || '') + '">'
      + '<a href="' + url + '" class="rm-card__media" tabindex="-1" aria-hidden="true">' + img + sale + '</a>'
      + '<div class="rm-card__body">'
      + '<a href="' + url + '" class="rm-card__title">' + esc(p.t) + '</a>'
      + '<p class="rm-card__meta">Ships in 1–3 days</p>'
      + '<div class="rm-card__foot"><div class="rm-card__prices">'
      + '<span class="rm-card__price">' + money(p.p) + '</span>' + was
      + '</div>' + action + '</div></div></div>';
  }

  /* ── Loading ── */
  function fromCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function toCache(list) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* done(list, complete, fail). complete is false when any page failed: the
     list is then only part of the catalogue and must not be cached, or every
     device on the missing page would be "not found" for the rest of the visit.
     fail says why, for the search report:
       http_<status>  the store answered with an error (429 = rate limited)
       html           a page came back instead of the index: a Cloudflare
                      challenge, a password page or a redirect
       bad_json       the index itself is malformed (a template bug)
       empty          the first page held no products
       timeout        no answer within 10 seconds
       network        the request never completed: offline, blocked by an
                      extension, or cancelled by navigating away */
  var TIMEOUT_MS = 10000;
  function Fail(why) { this.why = why; }

  /* Leaving the page cancels the fetch, which then reads as a "network"
     failure that never happened. The first night of data had 3 of 9 index
     loads "fail" this way: the buyer pressed Enter in the header box while the
     index was still loading, the browser went to the results page and the
     fetch was cut. So a search submit or a link click marks the page as
     leaving, and a cut fetch after that is not reported. */
  var leaving = false;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && /\/search(\?|$)/.test(f.getAttribute('action') || '')) leaving = true;
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    var href = a ? a.getAttribute('href') || '' : '';
    if (a && !a.target && href && href.charAt(0) !== '#' && !/^javascript:/i.test(href)) leaving = true;
  }, true);
  window.addEventListener('pagehide', function () { leaving = true; });
  function fetchAll(done) {
    var all = [];
    function page(n) {
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, TIMEOUT_MS) : null;
      // No Accept: application/json header. Shopify routes that to its own
      // JSON API rather than the alternate template and answers 404 — the
      // template only resolves for an HTML-ish request.
      fetch(INDEX_URL + '&page=' + n, ctl ? { signal: ctl.signal } : undefined)
        .then(function (r) {
          if (!r.ok) throw new Fail('http_' + r.status);
          return r.text();
        })
        .then(function (txt) {
          clearTimeout(timer);
          var batch;
          try { batch = JSON.parse(txt); }
          catch (e) { throw new Fail(/^\s*</.test(txt) ? 'html' : 'bad_json'); }
          if (!Array.isArray(batch)) throw new Fail('bad_json');
          if (n === 1 && !batch.length) throw new Fail('empty');
          all = all.concat(batch);
          // The index pages at 250; a short page means the end.
          if (batch.length === 250 && n < 12) page(n + 1);
          else done(all, true);
        })
        .catch(function (e) {
          clearTimeout(timer);
          var why = e instanceof Fail ? e.why : (e && e.name === 'AbortError' ? 'timeout' : 'network');
          done(all, false, { why: why, page: n, leaving: why === 'network' && leaving });
        });
    }
    page(1);
  }

  function ready(cb) {
    if (products) { cb(products); return; }

    var cached = fromCache();
    if (cached && cached.length) {
      products = cached;
      complete_ = true;   // only a complete index is ever cached
      buildCommonTags(products);
      cb(products);
      return;
    }

    // After three failed loads on one page, stop hammering the store; the full
    // search page still works.
    if (failures >= 3) { cb([]); return; }

    waiters.push(cb);
    if (loading) return;
    loading = true;
    var started = Date.now();
    fetchAll(function (list, complete, fail) {
      loading = false;
      var ok = complete && list.length > 0;
      complete_ = ok;
      // A fetch cut short by leaving the page is neither a failure nor news.
      var cut = !ok && fail && fail.leaving;
      if (!ok && !cut) failures++;
      // Reported once per page for a failure, so retries do not inflate it.
      if (window.RMSearchEvents && !cut && (ok || failures === 1)) {
        RMSearchEvents.index(list.length, Date.now() - started, ok, fail);
      }
      // An empty index used to be kept, so one failed fetch answered every
      // search on the page with "no mount matches". Leave it unloaded instead:
      // callers see isLoaded() false and the next keystroke tries again.
      if (list.length) {
        products = list;
        buildCommonTags(products);
        if (complete) toCache(list);
      }
      var w = waiters; waiters = [];
      w.forEach(function (fn) { fn(products || []); });
    });
  }

  function find(q, opts) {
    opts = opts || {};
    if (!products || !q) return [];
    var out = products.filter(function (p) { return matches(q, p); });
    out.sort(function (a, b) { return score(q, b) - score(q, a); });
    return opts.limit ? out.slice(0, opts.limit) : out;
  }

  /* ── Forgiving search ("Closest matches") ──
     Only ever asked when find() came back empty, so it cannot change an answer
     the strict matcher already gives. It forgives what buyers actually typed
     into zero results: a typo ("forewalla", "nvidia sheild"), a split model
     ("hp 800 g 6", "ser 9"), and extra words ("beelink ser8 with 32gb ram").
     What it must not do is hand back the wrong device, so:
       - a model code (letters and digits, or a 3+ digit number) is never
         fuzzed: "sg1008p" will not land on the SG1005P;
       - at least half the codes typed must be found, so "tl-sx1008" does not
         fall back to every TP-Link listing;
       - at least one hit must be a distinctive word or a code, so "dream
         machine pro" does not return whatever says "pro";
       - only the best-matching tier is shown.
     On when the theme setting search_loose is on (default since 2026-10-25).
     ?rm_loose=1 / ?rm_loose=0 force it on or off for one tab.
     The harness in tests/search-loose/ runs this exact code over the catalogue
     and the logged zero-result searches; run it before switching this on. */
  var LOOSE_STOP = { rack: 1, racks: 1, mount: 1, mounts: 1, mounting: 1, mini: 1, pc: 1, for: 1, with: 1,
    and: 1, the: 1, a: 1, an: 1, of: 1, to: 1, my: 1, in: 1, on: 1, modular: 1, kit: 1, bracket: 1,
    u: 1, x: 1, mod: 1, port: 1, ports: 1, case: 1, holder: 1, shelf: 1 };
  var WEAK_RATIO = 0.12;
  var weakWords = null;
  var allWords = [];

  function looseOn() {
    try {
      var m = /[?&]rm_loose=([01])/.exec(location.search || '');
      if (m) sessionStorage.setItem('rm-loose', m[1]);
      var s = sessionStorage.getItem('rm-loose');
      if (s === '1') return true;
      if (s === '0') return false;
    } catch (e) {}
    return window.RMSearchLooseOn === true;
  }

  /* Words on more than 12% of listings ("switch", "pro", "tp") still count as
     hits but cannot carry a match on their own. */
  function buildWeak(list) {
    weakWords = {};
    var df = {};
    list.forEach(function (p) {
      var seen = {};
      haystack(p).split(' ').forEach(function (w) { if (!seen[w]) { seen[w] = 1; df[w] = (df[w] || 0) + 1; } });
    });
    var cut = list.length * WEAK_RATIO;
    allWords = Object.keys(df);
    allWords.forEach(function (w) { if (df[w] > cut) weakWords[w] = 1; });
  }

  // "Soft" tokens shape the order but are never required: rack size, U height,
  // a version, a speed or capacity, a lone 1-2 digit number.
  function isSoft(t) {
    return /^(10|19)$/.test(t) || /^\d+u$/.test(t) || /^v\d+$/.test(t) || /^\d{1,2}$/.test(t)
      || /^\d+(gb|g|tb|w|mm|gbe|x)$/.test(t);
  }
  function isCode(t) { return /\d/.test(t) && (/[a-z]/.test(t) || t.length >= 3); }

  // Two typed words the catalogue writes as one ("bee link", "jet kvm",
  // "edgerouter x", "ser 9", "g 6") are joined when the joined form starts a
  // listing word. A 1-2 letter word before a short number is joined anyway
  // ("ms 02", "ps 5"), so it is judged as the model code it is.
  function startsWord(s) {
    for (var i = 0; i < allWords.length; i++) if (allWords[i].indexOf(s) === 0) return true;
    return false;
  }
  // parts[t] = how many typed words the token stands for, so a joined
  // "jetkvm" counts as two words found, not one.
  var parts = {};
  function looseTokens(q) {
    var raw = queryTokens(q), out = [];
    parts = {};
    for (var i = 0; i < raw.length; i++) {
      var t = raw[i], nx = raw[i + 1], n = 1;
      if (nx && !LOOSE_STOP[t] && !LOOSE_STOP[nx] && !/^(10|19)$/.test(nx) && startsWord(t + nx)) { t = t + nx; i++; n = 2; }
      else if (nx && /^[a-z]{1,2}$/.test(t) && /^\d{1,2}$/.test(nx) && !/^(10|19)$/.test(nx)) { t = t + nx; i++; }
      if (LOOSE_STOP[t] || out.indexOf(t) !== -1) continue;
      if (t.length === 1 && !/\d/.test(t)) continue;
      out.push(t);
      parts[t] = n;
    }
    return out;
  }

  // Optimal string alignment distance, stopping early past max.
  function dist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      var rowMin = max + 1;
      for (j = 1; j <= b.length; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        if (d[i][j] < rowMin) rowMin = d[i][j];
      }
      if (rowMin > max) return max + 1;
    }
    return d[a.length][b.length];
  }

  // Like matches() for one token, but stricter about where a hit may sit:
  // a short code ("g8") or a short word ("tech") must start a word, since
  // inside the squashed title "g8" is in "XG 8 PoE" and "tech" in "Sonnet Echo".
  // Returns 'w' (word), 'r' (model range) or null.
  function strictHit(t, words, squashed, p, soft) {
    var exact = /^\d+$/.test(t);
    for (var i = 0; i < words.length; i++) {
      if (exact ? words[i] === t : words[i].indexOf(t) === 0) return 'w';
      // A soft number may end a code: "nucbox 3" is the NucBox G3.
      if (soft && exact && t.length <= 2 && /^[a-z]+\d+$/.test(words[i]) && words[i].slice(-t.length) === t
          && !/\d/.test(words[i].charAt(words[i].length - t.length - 1))) return 'w';
    }
    if (!exact && (t.length >= 5 || (t.length >= 4 && isCode(t))) && squashed.indexOf(t) !== -1) return 'w';
    return inRange(t, p, false) ? 'r' : null;
  }

  // A plain word (no digits) may be one typo off a listing word, two when it
  // is 8+ letters, or one trailing letter long ("pie" for "pi"). A short word
  // must keep its first two letters, so "cosco" is not taken for "cisco".
  function fuzzyHit(t, words) {
    if (/\d/.test(t)) return null;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (/\d/.test(w)) continue;
      if (t.length >= 3 && w.length >= 2 && t.length === w.length + 1 && t.indexOf(w) === 0 && !weakWords[w]) return w;
      if (t.length < 5 || w.length < 4) continue;
      if (t.length <= 6 && t.slice(0, 2) !== w.slice(0, 2)) continue;
      var max = t.length >= 8 ? 2 : 1;
      for (var L = t.length - 1; L <= t.length + 1; L++) {
        if (L < 4 || L > w.length) continue;
        if (dist(t, w.slice(0, L), max) <= max) return w;
      }
    }
    return null;
  }

  // A code with letters ("g6", "ser8") names the device; a bare number
  // ("800") may be shared by several. So a lettered code weighs double.
  function weight(t) { return isCode(t) && /[a-z]/.test(t) ? 2 : 1; }

  function findLoose(q, opts) {
    opts = opts || {};
    if (!products || !q) return [];
    if (!weakWords) buildWeak(products);
    var toks = looseTokens(q);
    var need = toks.filter(function (t) { return !isSoft(t); });
    if (!need.length) return [];
    var codes = need.filter(isCode);
    var total = need.reduce(function (a, t) { return a + parts[t]; }, 0);

    var scored = [];
    products.forEach(function (p) {
      var hay = haystack(p), words = hay.split(' '), squashed = hay.replace(/ /g, '');
      var hits = 0, wsum = 0, strong = 0, codeHits = 0, exactHits = 0, rangeHits = 0, soft = 0;
      need.forEach(function (t) {
        var how = strictHit(t, words, squashed, p, false), w = t, fuzzy = false;
        if (!how) { w = fuzzyHit(t, words); fuzzy = !!w; }
        if (!how && !w) return;
        hits += parts[t];
        wsum += weight(t);
        if (how === 'r') rangeHits++;
        else if (!fuzzy) exactHits++;
        if (isCode(t)) { codeHits++; strong++; }
        else if (!weakWords[w] && !weakWords[t]) strong++;
      });
      if (!hits || !strong) return;
      // A number inside a model range ("4800" in OptiPlex 3000-7000) only
      // counts beside a real hit, or when the number is all that was typed.
      if (rangeHits && !exactHits && need.length > 1) return;
      if (codes.length && codeHits * 2 < codes.length) return;
      var ratio = hits / total;
      if (ratio < (codes.length && codeHits ? 0.5 : 0.6)) return;
      toks.forEach(function (t) { if (isSoft(t) && strictHit(t, words, squashed, p, true)) soft++; });
      scored.push({ p: p, tier: wsum, rank: ((wsum * 10 + exactHits) * 10 + soft) * 100000 + score(q, p) });
    });
    if (!scored.length) return [];
    var top = Math.max.apply(null, scored.map(function (s) { return s.tier; }));
    var out = scored.filter(function (s) { return s.tier === top; });
    out.sort(function (a, b) { return b.rank - a.rank; });
    out = out.map(function (s) { return s.p; });
    return opts.limit ? out.slice(0, opts.limit) : out;
  }

  window.RMSearch = {
    ready: ready,
    find: find,
    findLoose: findLoose,
    looseOn: looseOn,
    matches: matches,
    card: card,
    money: money,
    isLoaded: function () { return !!products; },
    // False while only part of the catalogue loaded: a zero then may be a
    // device on the missing page, not a real miss.
    isComplete: function () { return complete_; },
    size: function () { return products ? products.length : 0; }
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rm-typeahead"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__rmTypeaheadBound) return;
  window.__rmTypeaheadBound = true;

  var MIN_CHARS = 2;
  var LIMIT = 6;
  var DEBOUNCE = 220;

  function build(input) {
    // The panel is positioned against the input's form/wrapper, which needs to
    // be a positioning context.
    var anchor = input.closest('form') || input.parentElement;
    if (getComputedStyle(anchor).position === 'static') anchor.style.position = 'relative';

    var panel = document.createElement('div');
    panel.className = 'rm-ta';
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    anchor.appendChild(panel);

    var timer = null;
    var items = [];
    var active = -1;
    var surface = input.getAttribute('data-rm-surface') || 'other';
    var shownQ = '', shownTotal = 0, shownLoose = false;
    function ev() { return window.RMSearchEvents; }

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function highlight(i) {
      items.forEach(function (el, n) { el.setAttribute('aria-selected', String(n === i)); });
      active = i;
      if (items[i]) items[i].scrollIntoView({ block: 'nearest' });
    }

    // loose: these are closest matches for a query nothing matched (forgiving
    // search). Logged as 0 results with loose = how many were shown.
    function render(q, results, total, loose) {
      shownQ = q; shownTotal = loose ? 0 : total; shownLoose = !!loose;
      if (ev()) ev().shown(surface, q, loose ? 0 : total, loose ? { loose: results.length } : undefined);
      if (!results.length) {
        panel.innerHTML = '<p class="rm-ta__msg">No mount matches <strong>'
          + q.replace(/</g, '&lt;') + '</strong> yet.</p>'
          + '<a class="rm-ta__all" href="/pages/custom-orders?src=search&amp;model=' + encodeURIComponent(q.slice(0, 160)) + '">Request a custom design &rarr;</a>';
        items = [];
        open();
        return;
      }

      var html = results.map(function (p) {
        var was = p.c > p.p ? '<s>' + window.RMSearch.money(p.c) + '</s>' : '';
        var img = p.m
          ? '<img class="rm-ta__thumb" src="' + p.m + '" alt="" loading="lazy" width="44" height="44">'
          : '<span class="rm-ta__thumb"></span>';
        return '<a class="rm-ta__item" role="option" aria-selected="false" href="/products/' + p.h + '" data-pid="' + (p.d || '') + '">'
          + img
          + '<span class="rm-ta__text"><span class="rm-ta__title">'
          + p.t.replace(/&/g, '&amp;').replace(/</g, '&lt;')
          + '</span><span class="rm-ta__price">' + window.RMSearch.money(p.p) + was + '</span></span></a>';
      }).join('');

      if (loose) {
        html = '<p class="rm-ta__msg">No exact match. Closest mounts:</p>' + html
          + '<a class="rm-ta__all" href="/pages/custom-orders?src=search&amp;model=' + encodeURIComponent(q.slice(0, 160)) + '">Not it? Request a custom design &rarr;</a>';
      } else if (total > results.length) {
        html += '<a class="rm-ta__all" href="/search?type=product&options%5Bprefix%5D=last&q='
          + encodeURIComponent(q) + '">See all ' + total + ' matches &rarr;</a>';
      }

      panel.innerHTML = html;
      items = Array.prototype.slice.call(panel.querySelectorAll('.rm-ta__item'));
      highlight(-1);
      open();
    }

    function run() {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { close(); return; }

      if (!window.RMSearch) { close(); return; }

      if (!window.RMSearch.isLoaded()) {
        panel.innerHTML = '<p class="rm-ta__msg">Searching the catalogue&hellip;</p>';
        items = [];
        open();
      }

      window.RMSearch.ready(function () {
        // The buyer may have typed on since this load started.
        var now = input.value.trim();
        if (now.length < MIN_CHARS) { close(); return; }
        if (!window.RMSearch.isLoaded()) {
          // The catalogue failed to load. Saying "no mount matches" here would
          // be a lie; Enter still reaches the full search page.
          panel.innerHTML = '<p class="rm-ta__msg">Results did not load. Press Enter to search.</p>';
          items = [];
          shownQ = now; shownTotal = 0;
          if (ev()) ev().shown(surface, now, 0, { err: 'index' });
          open();
          return;
        }
        var all = window.RMSearch.find(now);
        if (!all.length && window.RMSearch.findLoose && window.RMSearch.looseOn()) {
          var close = window.RMSearch.findLoose(now, { limit: LIMIT });
          if (close.length) { render(now, close, close.length, true); return; }
        }
        render(now, all.slice(0, LIMIT), all.length);
      });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { close(); return; }
      // Warm the index on the very first keystroke so results feel instant.
      if (window.RMSearch && !window.RMSearch.isLoaded()) window.RMSearch.ready(function () {});
      timer = setTimeout(run, DEBOUNCE);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && items.length) open();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden || !items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight((active + 1) % items.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight((active - 1 + items.length) % items.length); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items[active].click(); }
      else if (e.key === 'Escape') { close(); }
    });

    document.addEventListener('click', function (e) {
      if (!anchor.contains(e.target)) close();
    });

    // A result opened, by mouse, tap or Enter (Enter clicks the item).
    panel.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || !ev()) return;
      var pos = items.indexOf(a);
      if (pos > -1) ev().click(surface, shownQ, a.getAttribute('data-pid'), pos + 1, shownTotal, shownLoose ? { loose: 1 } : undefined);
      else if (a.classList.contains('rm-ta__all')) {
        ev().click(surface, shownQ, '', 0, shownTotal, { to: /custom/.test(a.getAttribute('href')) ? 'custom' : 'all' });
      }
    });

    var form = input.closest('form');
    if (form) form.addEventListener('submit', function () {
      if (ev()) ev().submit(surface, input.value);
    });
  }

  function init() {
    document.querySelectorAll('[data-rm-typeahead]').forEach(build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
